export default __webpack_public_path__ + "media/images/ic-cost-3-357e68c2c4892ee96a17820178a6b6e9.png";